/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { Typography, Grid, Box, Divider, Collapse } from '@mui/material';
import { Check as CheckIcon } from '@mui/icons-material';
import { useState } from 'react';
import { GeneralModal, OutlinedButton, ContainedButton } from '../index';

export const ReminderPopupModal = (props) => {
  const reminders = props.reminders || [];
  const [exitingIds, setExitingIds] = useState([]);
  const [confirmedIds, setConfirmedIds] = useState([]);
  const [confirmingId, setConfirmingId] = useState(null);

  const handleConfirmOne = (reminder) => {
    setConfirmingId(reminder._id);
    const remainingCount = reminders.filter(
      (r) => !confirmedIds.includes(r._id)
    ).length;

    Promise.resolve(props.onConfirmOne(reminder))
      .then(() => {
        setConfirmingId(null);

        if (remainingCount === 1) {
          props.onAllConfirmed();
          return;
        }

        setExitingIds((prev) => [...prev, reminder._id]);

        setTimeout(() => {
          setConfirmedIds((prev) => {
            const next = [...prev, reminder._id];
            if (next.length === reminders.length) {
              props.onAllConfirmed();
            }
            return next;
          });
        }, 300);
      })
      .catch((err) => {
        console.log(err);
        setConfirmingId(null);
      });
  };

  const visibleReminders = reminders.filter(
    (reminder) => !confirmedIds.includes(reminder._id)
  );

  return (
    <GeneralModal
      open={props.open}
      onClose={() => {}}
      style={{
        width: '45%',
        maxHeight: '80vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Typography
        align="center"
        sx={{ mb: 2, fontWeight: 600, flexShrink: 0 }}
        variant="h5"
      >
        Reminders
      </Typography>
      <Box sx={{ overflowY: 'auto', flex: 1, minHeight: 0, pr: 1 }}>
        {visibleReminders.map((reminder, index) => (
          <Collapse
            key={reminder._id}
            in={!exitingIds.includes(reminder._id)}
            timeout={300}
          >
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                {reminder.title}
              </Typography>
              <Typography sx={{ mt: 0.5, whiteSpace: 'pre-line' }}>
                {reminder.message}
              </Typography>
              {reminder.links?.length > 0 && (
                <Grid container spacing={2} sx={{ mt: 0.5 }}>
                  {reminder.links.map((link, linkIndex) => (
                    <Grid item xs={6} key={linkIndex}>
                      <OutlinedButton
                        btnTitle={link.label}
                        href={link.url}
                        target="_blank"
                        fullWidth
                      />
                    </Grid>
                  ))}
                </Grid>
              )}
              <Grid container justifyContent="center" sx={{ mt: 2 }}>
                <ContainedButton
                  btnTitle="Confirm"
                  startIcon={<CheckIcon />}
                  onClick={() => handleConfirmOne(reminder)}
                  disabled={confirmingId === reminder._id}
                  style={{ width: 200 }}
                />
              </Grid>
              {index < visibleReminders.length - 1 && (
                <Divider sx={{ mt: 2 }} />
              )}
            </Box>
          </Collapse>
        ))}
      </Box>
    </GeneralModal>
  );
};
